import { IdentifierDTO } from '@zazume/zzm-base';

import { UserBureauData } from '#/models/UserBureauData';

import { doGet } from '../../helpers';

export const bureau = {
  getByBackgroundCheckId: (backgroundCheckId: IdentifierDTO) => () =>
    doGet<UserBureauData | undefined>(`/bureau/background-check/${backgroundCheckId}`)
};
